// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__35pPI","container":"LayoutSideNavigation_container__26tXa","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__1RU-S"};